import { render, staticRenderFns } from "./WordsStats.vue?vue&type=template&id=537a3e73&"
import script from "./WordsStats.vue?vue&type=script&lang=js&"
export * from "./WordsStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports